import React from "react";
import { useNavigate } from "react-router-dom";

import { Button, Box, Typography, Container, Paper } from "@mui/material";
import { Home, Google } from "@mui/icons-material";

export default function SignIn() {
  const navigate = useNavigate();
  
  return (
    <Container component="main" maxWidth="xs" className="text-focus-in">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "100vh",
        }}
      >
        <Paper elevation={3} sx={{ padding: 3 }}>
          <Container>
            <Typography component="h1" variant="h5" textAlign="center" sx={{ mb: 2 }}>
              Sign in with
            </Typography>

            <Button fullWidth variant="outlined" size="large" title="Sign in with Google" startIcon={<Google />} sx={{ mb: 2 }} className="vibrate-1">
              Google
            </Button>

            <Button
              fullWidth
              variant="outlined"
              size="large"
              title="Go Home"
              startIcon={<Home />}
              sx={{ mb: 2 }}
              onClick={() => {
                navigate("/");
              }}
              className="vibrate-1"
            >
              Home
            </Button>
          </Container>
        </Paper>
      </Box>
    </Container>
  );
}
